(function () {
  'use strict';

  var SEL_PILLS   = '.ocol-pills';
  var SEL_WRAPPER = '.main-collection-section';
  var SEL_GRILLE  = '.main_collection_product_grid';

  function idSection() {
    var e = document.querySelector('[data-section-id]');
    return e ? e.dataset.sectionId : null;
  }

  function remonter() {
    var w = document.querySelector(SEL_WRAPPER);
    if (!w) return;
    var y = w.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(y, { immediate: false });
    } else {
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  function charger(href, pousserHistorique) {
    var id = idSection();
    var wrapper = document.querySelector(SEL_WRAPPER);
    if (!id || !wrapper) return false;

    var u = new URL(href, window.location.origin);
    u.searchParams.set('sections', id);

    wrapper.setAttribute('aria-busy', 'true');

    fetch(u.toString())
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data[id]) throw new Error('section absente');
        var doc = new DOMParser().parseFromString(data[id], 'text/html');
        var neuf = doc.querySelector(SEL_WRAPPER);
        if (!neuf) throw new Error('wrapper absent de la reponse');

        wrapper.innerHTML = neuf.innerHTML;

        if (typeof window.orleaFadeCartes === 'function') {
          window.orleaFadeCartes(wrapper.querySelector(SEL_GRILLE));
        }

        if (pousserHistorique) {
          var propre = new URL(href, window.location.origin);
          propre.searchParams.delete('sections');
          window.history.pushState({ orleaPills: true }, '', propre.toString());
        }

        document.querySelectorAll('quick-add-button').forEach(function (el) {
          if (typeof el.attachEvents === 'function') el.attachEvents();
        });

        wrapper.removeAttribute('aria-busy');
        remonter();
      })
      .catch(function () {
        wrapper.removeAttribute('aria-busy');
        window.location.href = href;
      });

    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var lien = e.target.closest && e.target.closest(SEL_PILLS + ' a[href]');
    if (!lien) return;

    var href = lien.getAttribute('href');
    if (!href || href.charAt(0) !== '/' || href.indexOf('/collections/') !== 0) return;

    if (charger(href, true)) {
      e.preventDefault();
    }
  });

  window.addEventListener('popstate', function () {
    if (document.querySelector(SEL_WRAPPER)) {
      charger(window.location.pathname + window.location.search, false);
    }
  });
})();